module.exports = __webpack_public_path__ + "static/media/msme.ae0eea49.png";